import store from "@/store";

export const func = {
  scrollHandler: () => {
    store.state.lastPos = window.scrollY;
  },
};
